import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return(
      <div className="footer">
        <div>
          <h3>GIFT CARDS</h3>
          <h3>STUDENT DISCOUNTS</h3>
          <h3>MILITARY DISCOUNTS</h3>
          <h3>FIND A STORE</h3>
          <h3>SIGN UP FOR EMAIL</h3>
          <h3>BECOME A MEMBER</h3>
          <h3>PROVIDE FEEDBACK</h3>
        </div>
        <div>
          <h3>CONTACT US</h3>
          <p>Order Status</p>
          <p>Shipping and Delivery</p>
          <p>Returns</p>
          <p>Payment Options</p>
          <p>Contact Us</p>
        </div>
        <div>
          <h3>ABOUT MANGO-BYTES 2.0</h3>
          <p>News</p>
          <p>Careers</p>
          <p>Converse Culture & Careers</p>
          <p>Investors</p>
          <p>Sustainable Innovation</p>
          <p>CA Supplychain Act</p>
        </div>
      </div>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer.js